import React, { useEffect, useState } from 'react';
import { useTransition, animated, useSpringRef } from '@react-spring/web'

import apiCall, { LIVE_URL, TEST_URL } from '~/utils/apiCall';
import dabangBridge from '~/utils/bridge';

import useAuth from '~/hooks/useAuth';

import BG from '~/components/background';

import q1 from './images/q1.png';
import q2 from './images/q2.png';
import q3 from './images/q3.png';
import q4 from './images/q4.png';
import q5 from './images/q5.png';
import q6 from './images/q6.png';
import q7 from './images/q7.png';

import { QuizWrap } from './styled';

function QuizComponent() {
  const [step, setStep] = useState(0);
  const [quizArr, setQuizArr] = useState([]);

  const transRef = useSpringRef()
  const transitions = useTransition(step, {
    ref: transRef,
    key: step,
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    config: { duration: 500 },
  });

  const { authKey } = useAuth();

  const QUIZ_IMG = [q1, q2, q3, q4, q5, q6, q7];

  useEffect(() => {
    if (quizArr.length === 7) submit();
  }, [quizArr]);

  useEffect(() => {
    transRef.start();
  }, [step]);

  function close() {
    dabangBridge.android(call => {
      call.finishActivity();
    });

    dabangBridge.ios(call => {
      call.callHandler('iOS Echo', {
        cmd: 'finishActivity',
      });
    });
  }

  async function submit() {
    try {
      const res = await apiCall.post(`${LIVE_URL}/api/v1/event/2022/bluemarble`, { authKey, answerList: quizArr });
      const type = res?.result ?? 'gangnam';
      const errorCode = [501, 502, 503, 504, 505, 506, 507, 508];

      if (!res) {
        alert('본 이벤트는 조기 마감되었습니다. 감사합니다.');
        close();

      } else {
        if (errorCode.includes(res.code)) {
          alert(res.msg);

          if (res.code === 501) {                   // 로그인 안되어 있는 경우 로그인 페이지로 이동하는 브릿지
            dabangBridge.ios(call => {
              call.callHandler('ObjC Echo', {
                cmd: 'showLoginAndReload',
              });
            });
        
            dabangBridge.android(call => {
              console.log('android');
              call.showLoginAndReload();
            });
            
          } else if (res.code === 502 || res.code === 508) {            // 본인인증 페이지로 이동
            dabangBridge.ios(call => {
              call.callHandler('ObjC Echo', {
                cmd: 'showAuthAndReload',
              });
            });
        
            dabangBridge.android(call => {
              console.log('android');
              call.showAuthAndReload();
            });
          }

        } else if (res.code === 200) {
          alert('이벤트에 응모 되었습니다.');
          window.location.replace(`/2022/04/dbti/result/?type=${type.toLowerCase()}&auth_key=${authKey}`);
        }
      }

    } catch(err) {
      console.log(err);
      alert(err?.msg ?? '서버에러가 발생했습니다.');
    }
  }

  function clickAnswer(val) {
    setStep(prev => {
      return prev + 1;
    });

    setQuizArr(prev => {
      const temp = [...prev];
      temp.push(val);
      return temp;
    });
  }

  return (
    <QuizWrap>
      {transitions((style, i) => {
        if (i >= 7) return <animated.img style={style} src={QUIZ_IMG[6]} alt="" />;
        return <animated.img style={style} src={QUIZ_IMG[i]} alt="" />;
      })}
      <BG width={710} height={1388} imgUrl={''} />
      <button className="a-1" onClick={clickAnswer.bind(null, 'A')} />
      <button className="a-2" onClick={clickAnswer.bind(null, 'B')} />
    </QuizWrap>
  );
}

export default QuizComponent;
